<template>
    <page>
        <module enable-flex>
            <c-tab-list ref="tabList" :tabs="tabList" type="border-tab" @change="tableHandle"></c-tab-list>
            <m-search v-show="currentTabValue == 2" ref="treeSearch" key="tree" @search="searchTreeHandle">
                <m-search-item label="分组名称">
                    <c-input name="group_name"></c-input>
                </m-search-item>
                <m-search-item label="分类">
                    <c-select name="category_id" async @search="searchCategory"></c-select>
                </m-search-item>
            </m-search>
            <m-search v-show="currentTabValue == 1" ref="search" key="list" @search="searchHandle">
                <m-search-item label="质检项值">
                    <c-input name="name"></c-input>
                </m-search-item>
                <m-search-item label="分类">
                    <c-select name="category_id" v-model="categoryId" async @search="searchCategory"></c-select>
                </m-search-item>
                <m-search-item label="分组">
                    <c-select name="release_group_id" v-model="releaseGroupId" async
                              @search="searchReleaseGroupId"></c-select>
                </m-search-item>
                <m-search-item label="质检项">
                    <c-select name="parent_id" v-model="parentId" async @search="searchReleaseParent"></c-select>
                </m-search-item>
                <m-search-item label="是否瑕疵项">
                    <c-select name="release_type" :options="releaseTypeOptions"></c-select>
                </m-search-item>
                <m-search-item label="状态">
                    <c-checkbox-group name="status" :options="disableEnableDic"></c-checkbox-group>
                </m-search-item>
            </m-search>

            <m-operate>
                <c-button color="main" v-if="auth('b_release_group_edit') && currentTabValue == 2" prepend-icon="tf-add" @click="$refs.releaseGroupEdit.open()">添加质检分组</c-button>
                <c-button color="main" v-if="auth('b_release_edit') && currentTabValue == 1" prepend-icon="tf-add" @click="$refs.releaseEdit.open()">添加质检项值</c-button>
            </m-operate>
            <!--树形表格-->
            <c-table v-show="currentTabValue == 2" ref="tree_list" height="grow" width-resize>
                <c-table-column label="ID" name="id" width="80" fixed="left"></c-table-column>
                <c-table-column
                        type="tree"
                        label="分组名称"
                        :add-node="addNodeText"
                        level-limit="3"
                        width="300"
                        @handle="loadChildren"
                        @add="addHandle"
                        fixed="left"
                >
                    <template #default="{data}">
                        <span v-if="data.level == 0">{{ data.group_name }}</span>
                        <span v-if="data.level == 1">{{ data.name }}</span>
                        <span v-if="data.level == 2 && data.release_type == 1" style="color:green;">{{ data.name }}</span>
                        <span v-if="data.level == 2 && data.release_type == 2" style="color: red">
                            {{ data.name }} <span v-if="data.defect_image == 1">（需传图）</span>
                        </span>
                    </template>
                </c-table-column>
                <c-table-column label="所属分类" name="category_name" width="150" :ellipsis="false"></c-table-column>
                <c-table-column label="备注" name="remark" width="150">
                    <template #default="{data}">
                        <span v-if="data.remark">{{ data.remark }}</span>
                        <span v-else>-</span>
                    </template>
                </c-table-column>
                <c-table-column label="创建人" name="create_user_name" width="150"></c-table-column>
                <c-table-column label="创建时间" name="create_date" width="140"></c-table-column>
                <c-table-column label="排序" type="sort" fixed="right" @handle="sortHandle"></c-table-column>
                <!-- 是否启用 -->
                <c-table-column
                        label="状态"
                        name="status"
                        width="80"
                        fixed="right"
                >
                    <template #default="{data}">
                        <c-switch v-if="auth('b_release_group_edit')" v-model="data.status" :state-value="[1, 0]"
                                  :state-text="['启用','禁用']"
                                  @beforeChange="stateHandle(arguments[0], arguments[1], data)"></c-switch>
                        <c-state v-else dict="disableEnableDic" :value="data.status"></c-state>
                    </template>
                </c-table-column>
                <c-table-column type="button" label="操作" width="135" button-limit="6">
                    <template #default="row">
                        <c-table-button v-if="auth('b_release_channel_set') && row.data.level == 0" icon="tf-related" @click="$refs.channelRefEdit.open(row.data,row.data.group_name,'release_group')">渠道映射</c-table-button>
                        <c-table-button v-if="auth('b_release_channel_set') && row.data.level == 1" icon="tf-related" @click="$refs.channelRefEdit.open(row.data,row.data.name,'release_parent')">渠道映射</c-table-button>
                        <c-table-button v-if="auth('b_release_channel_set') && row.data.level == 2" icon="tf-related" @click="$refs.channelRefEdit.open(row.data,row.data.name,'release')">渠道映射</c-table-button>

                        <c-table-button v-if="auth('b_release_group_edit') && row.data.level == 0" icon="tf-edit" @click="$refs.releaseGroupEdit.open(row.data)">编辑</c-table-button>
                        <c-table-button v-if="auth('b_release_edit') && row.data.level == 1" icon="tf-edit" @click="editReleaseParent(row.data,row.update)">编辑</c-table-button>
                        <c-table-button v-if="auth('b_release_edit') && row.data.level == 2" icon="tf-edit" @click="editRelease(row.data,row.update)">编辑</c-table-button>

                        <c-table-button v-if="auth('b_release_edit')" icon="tf-trash" color="red" @click="removeRelease(row.data,row)">删除</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
            <!--列表表格-->
            <c-table v-show="currentTabValue == 1" ref="list" height="grow" width-resize>
                <c-table-column label="ID" name="id" width="80" fixed="left"></c-table-column>
                <c-table-column label="质检项值" name="name" width="100" fixed="left">
                    <template #default="{data}">
                        <span v-if="data.release_type == 2" style="color: red">{{ data.name }}</span>
                        <span v-else style="color:green;">{{ data.name }}</span>
                    </template>
                </c-table-column>
                <c-table-column label="是否瑕疵项" name="release_type" width="100">
                    <template #default="{data}">
                        <span v-if="data.release_type == 2" style="color: red">瑕疵项</span>
                        <span v-else style="color:green;">正常项</span>
                    </template>
                </c-table-column>
                <c-table-column label="是否需传瑕疵图" name="release_type" width="100">
                    <template #default="{data}">
                        <span v-if="data.release_type == 2 && data.defect_image == 2" style="color: green">无需图</span>
                        <span v-else-if="data.release_type == 2 && data.defect_image == 1" style="color: red">需传图</span>
                        <span v-else style="color:green;">-</span>
                    </template>
                </c-table-column>
                <c-table-column label="质检项" name="parent_name" width="100"></c-table-column>
                <c-table-column label="所属分组" name="group_name" width="100"></c-table-column>
                <c-table-column label="所属分类" name="category_name" width="150" :ellipsis="false"></c-table-column>
                <c-table-column label="备注" name="remark" width="150">
                    <template #default="{data}">
                        <span v-if="data.remark">{{ data.remark }}</span>
                        <span v-else>-</span>
                    </template>
                </c-table-column>
                <c-table-column label="创建人" name="create_user_name" width="150"></c-table-column>
                <c-table-column label="创建时间" name="create_date" width="140"></c-table-column>
                <c-table-column
                        label="排序"
                        type="sort"
                        fixed="right"
                        @handle="sortHandle">
                </c-table-column>
                <!-- 是否启用 -->
                <c-table-column
                        label="状态"
                        name="status"
                        width="80"
                        fixed="right"
                >
                    <template #default="row">
                        <c-switch v-if="auth('b_release_group_edit')" v-model="row.data.status" :state-value="[1, 0]"
                                  :state-text="['启用','禁用']"
                                  @beforeChange="stateHandle(arguments[0], arguments[1], row.data,row)"></c-switch>
                        <c-state v-else dict="disableEnableDic" :value="row.data.status"></c-state>
                    </template>
                </c-table-column>
                <c-table-column type="button" label="操作" width="135" button-limit="6">
                    <template #default="{data}">
                        <c-table-button v-if="auth('b_release_channel_set')" icon="tf-related" @click="$refs.releaseChannelRefEdit.open(data)">渠道映射</c-table-button>
                        <c-table-button v-if="auth('b_release_edit')" icon="tf-edit" @click="editRelease(data)">编辑</c-table-button>
                        <c-table-button v-if="auth('b_release_edit') && data.status == 2" icon="tf-trash" color="red" @click="removeRelease(data)">删除</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
            <!--新增/编辑分组-->
            <release-group-edit ref="releaseGroupEdit" @resolve="$refs.tree_list.update()"></release-group-edit>
            <!--新增/编辑质检项-->
            <release-parent-edit ref="releaseParentEdit" @resolve="reloadTree"></release-parent-edit>
            <!--新增/编辑质检项值弹窗-->
            <release-edit ref="releaseEdit" @resolve="reloadTree"></release-edit>
            <!--设置关联渠道信息弹窗-->
            <channel-ref-edit ref="channelRefEdit"></channel-ref-edit>
            <!--质检项值渠道映射弹窗（release_channel_ref）-->
            <release-channel-ref-edit ref="releaseChannelRefEdit"></release-channel-ref-edit>
        </module>
    </page>
</template>

<script>
import releaseGroupEdit from "@/pages/spv/release_group_edit.vue";
import releaseParentEdit from "@/pages/spv/release_parent_edit.vue";
import releaseEdit from "@/pages/spv/release_edit.vue";
import channelRefEdit from "@/pages/spv/channel_ref_edit.vue";
import releaseChannelRefEdit from "@/pages/spv/release_channel_ref_edit.vue";

import {mapState} from "vuex";

export default {
    components: {
        releaseGroupEdit,
        releaseParentEdit,
        releaseEdit,
        channelRefEdit,
        releaseChannelRefEdit
    },

    computed: {
        // 获取dictName选项数据
        ...mapState(['disableEnableDic'])
    },

    data() {
        return {
            _resolve: null,
            editLevel: -1,           //当前编辑等级（负数表示非树）
            tabList: [
                {name: '按树形查看', value: 2},
                {name: '按表格查看', value: 1}
            ],
            currentTabValue: 2,   //2=按树形查看  1=按表格查看
            categoryId: 0,         //已选中的分类ID
            releaseGroupId: 0,     //已选中的分组ID
            parentId: 0,           //已选中的父项ID
            releaseTypeOptions: [
                {name: '正常项', value: '1'},
                {name: '瑕疵项', value: '2'}
            ]
        }
    },

    methods: {
        /*******搜索分类*****************/
        searchCategory(keyword, resolve) {
            this.request({
                url: '/spu/category/options',
                data: {
                    keyword: keyword
                },
                success: data => {
                    resolve(data);
                }
            })
        },

        /*******搜索分组*****************/
        searchReleaseGroupId(keyword, resolve) {
            this.request({
                url: '/spu/release/group/options',
                data: {
                    category_id: this.categoryId,
                    keyword: keyword
                },
                success: data => {
                    resolve(data);
                }
            })
        },

        /*******搜索父级质检项*****************/
        searchReleaseParent(keyword, resolve) {
            this.request({
                url: '/spu/release/parent/options',
                data: {
                    category_id: this.categoryId,
                    release_group_id: this.releaseGroupId,
                    keyword: keyword
                },
                success: data => {
                    resolve(data);
                }
            })
        },
        //根据父项加载子项
        loadChildren(row, resolve) {
            let paramData = {};
            if (row.data.level == 0) {       //展开分组-展示其下的【质检项】
                paramData.release_group_id = row.data.id;
            } else if (row.data.level == 1) { //展开质检项-展示其下的【质检项值】
                paramData.parent_id = row.data.id;
                paramData.paging = 0;//不分页展示（最多展示999条数据）
            }
            this.request({
                url: row.data.level == 0 ? '/spu/release/parent/list' : '/spu/release/list',
                data: paramData,
                success: data => {
                    resolve(data);
                }
            });
        },
        //添加节点文案：一级分组下添加质检项，二级质检项下添加质检项值
        addNodeText(row) {
            return row.data.level == 1 ? '添加质检项值' : '添加质检项';
        },
        //添加树数据行
        addHandle(row, resolve) {
            this.editLevel = row.nodeData.level;
            if (this.editLevel == 0) {//添加质检项
                this.$refs.releaseParentEdit.open(null, row.data.id);
            }
            if (this.editLevel == 1) {//添加质检项值
                this.$refs.releaseEdit.open(null, row.data.id);
            }
            this._resolve = data => {
                resolve(data);
            };
        },
        //切换Tab
        tableHandle(tab) {
            this.currentTabValue = tab.value;
            this.$nextTick(() => {
                if (this.currentTabValue == 2) {
                    this.editLevel = 0;
                    let tree_list = this.$refs.tree_list.getRow().map((item, index) => {
                        return item.data;
                    });
                    if (!tree_list || tree_list.length == 0) {
                        this.$refs.treeSearch.clear();
                        this.$refs.treeSearch.search();
                    }
                } else {
                    this.editLevel = -1;
                    // this.$refs.search.clear();
                    this.$refs.search.search();
                }
            });
        },

        /********搜索************/
        searchTreeHandle(data) {
            this.$refs.tree_list.load({
                url: '/spu/release/group/list',
                data
            });
        },

        /********搜索************/
        searchHandle(data) {
            this.$refs.list.load({
                url: '/spu/release/list',
                data
            })
        },

        /******编辑质检项***********/
        editReleaseParent(rowData, update) {
            this.$refs.releaseParentEdit.open(rowData, rowData.release_group_id);
            this._resolve = data => {
                update(data);
            };
        },
        /******编辑质检项值***********/
        editRelease(rowData, update) {
            this.$refs.releaseEdit.open(rowData, rowData.release_group_id);
            this._resolve = data => {
                update(data);
            };
        },

        /******启禁用*********/
        stateHandle(state, next, rowData, row) {
            let url = '/spu/release/edit/status';
            if (rowData.level == 0) {
                url = '/spu/release/group/edit/status';
            } else if (rowData.level == 1) {
                url = '/spu/release/parent/edit/status';
            } else if (rowData.level == 2) {
                url = '/spu/release/edit/status';
            }
            this.request({
                url: url,
                data: {
                    id: rowData.id,
                    status: state ? 2 : 1   //1：启用； 2：禁用
                },
                success: () => {
                    this.$message({
                        message: '操作成功',  // 提示内容,
                        type: 'success'
                    });
                    if (row) {
                        row.update();
                    }
                    next();
                }
            })
        },

        sortHandle(row, type, next) {
            if (this.currentTabValue == 1) {
                this.listSortHandle('/spu/release/sort', row, type, next);
            } else if (this.currentTabValue == 2) {
                if (row.data.level == 0) {
                    this.listSortHandle('/spu/release/group/sort', row, type, next);
                } else if (row.data.level == 1) {
                    this.treeSortHandle('/spu/release/parent/tree_sort', row, type, next);
                } else if (row.data.level == 2) {
                    this.treeSortHandle('/spu/release/tree_sort', row, type, next);
                }
            }
        },

        /********************表格数据排序**************************/
        treeSortHandle(url, row, type, next) {
            this.request({
                url: url,
                data: {
                    id: row.data.id,
                    type: type
                },
                loading: true,
                success: data => {
                    next();
                }
            });
        },

        /********************列表排序**************************/
        listSortHandle(url, row, type, next) {
            this.request({
                url: url,
                data: {
                    id: row.data.id,
                    type: ['top', 'bottom'].includes(type) ? type : '',
                    id1: type == 'up' ? row.prev().data.id : type == 'down' ? row.data.id : '',
                    id2: type == 'up' ? row.data.id : type == 'down' ? row.next().data.id : '',
                },
                loading: true,
                success: data => {
                    // next();
                    this.$refs.list.update();
                }
            });
        },

        /******删除数据***********/
        removeRelease(rowData, row) {
            let url = "/spu/release/group/remove";
            let msg = "";
            if (rowData.level == 0) {
                url = "/spu/release/group/remove";
                msg = '确认删除质检分组【' + rowData.group_name + '】？删除分组将导致其关联的所有质检项数据不可用，请谨慎操作';
            } else if (rowData.level == 1) {
                url = "/spu/release/parent/remove";
                msg = '确认删除质检项【' + rowData.name + '】？删除质检项将导致其关联的所有质检项值数据不可用，请谨慎操作';
            } else if (rowData.level == 2) {
                url = "/spu/release/remove";
                msg = '确认删除质检项值【' + rowData.name + '】？删除后不可恢复';
            }
            this.$confirm({
                message: msg,  // 提示内容,
                buttonName: '确定删除',  // 确定按钮文字
                cancelButton: true,  // 是否显示取消按钮
                resolve: () => {
                    this.request({
                        url: url,
                        data: {id: rowData.id},
                        loading: true,
                        success: data => {
                            this.$message({
                                message: '删除成功',  // 提示内容,
                                type: 'success'
                            });
                            if (row) {
                                row.remove();
                            } else {
                                this.$refs.list.update();
                            }
                        }
                    });
                },  // 确定按钮回调
                cancel: () => {
                },  // 取消按钮回调
            });
        },

        /***********刷新列表**************/
        reloadTree(res) {
            //刷新表格
            if (this.editLevel == -1) {
                this.$refs.list.update();
            } else {
                this._resolve(res);
            }
        }
    }
}
</script>

<style lang="stylus" scoped>
</style>